import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-col space-y-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-full space-y-4"
}

import { computed, ref } from "vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import { useAuthStore } from "@/store/useAuthStore";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import InputText from "@/components/Form/InputText.vue";
import ButtonPrimary from "@/components/Buttons/ButtonPrimary.vue";
import TextSmall from "@/components/Texts/TextSmall.vue";
import FriendRequestManageView from "@/components/Friends/FriendRequestManageView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAddViewContainer',
  setup(__props) {

const friendsStore = useFriendsStore();
const authStore = useAuthStore();

const nameValue = ref("");

const error = ref(false);
const success = ref(false);

const addFriend = () => {
  error.value = false;
  success.value = false;
  const isSuccess = friendsStore.addFriendRequest(
    authStore.currentUser.id,
    nameValue.value
  );
  if (isSuccess) {
    success.value = true;
  } else {
    error.value = true;
  }
};

const friendsRequestFromMe = computed(() => {
  return friendsStore.friendRequestsFromMe;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleMedium, { text: "My requests" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputText, {
        name: "name",
        is_required: true,
        id: "name",
        modelValue: nameValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameValue).value = $event)),
        placeholder: "Name",
        type: "text"
      }, null, 8, ["modelValue"]),
      _createVNode(ButtonPrimary, {
        text: "Add",
        onClick: addFriend
      }),
      (success.value)
        ? (_openBlock(), _createBlock(TextSmall, {
            key: 0,
            text: "The friend request has been successfully sent !",
            class: "text-green-300"
          }))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(TextSmall, {
            key: 1,
            text: "This user does not exist",
            class: "text-red-500"
          }))
        : _createCommentVNode("", true)
    ]),
    (friendsRequestFromMe.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendsRequestFromMe.value, (friend) => {
            return (_openBlock(), _createBlock(FriendRequestManageView, {
              key: friend.to,
              "friends-request": friend
            }, null, 8, ["friends-request"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})